import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getMindfile } from './../../../../state/actions/getDataActions'
import { Link } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@mui/icons-material/Menu'
import Hidden from '@material-ui/core/Hidden'
import MindfileBar from '../mindfile-bar/MindfileBar';

const styles = theme => ({
  appBar: {
    color: '#002f43',
    backgroundImage: 'radial-gradient(circle at 30%, white, #C2C2C2, #C2C2C2)',
  },
  grow: {
    flexGrow: 1,
  },
  logo: {
    height: 24,
  },
  menuButton: {

  },
  toolbar:{
    '& > *':{
      height:'64px',
      boxSizing:'border-box'
    }
  }
})

class MainAppBar extends Component {
  state = {
  }

  render() {
    const { classes } = this.props
    return (
      <AppBar id="appBarMain" position="static" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <div className={classes.grow}>
            <MindfileBar />
          </div>
          <Hidden smDown>
            <Button color="inherit" component={Link} to='/explore'>Explore</Button>
            {/*<Button color="inherit" component={Link} to='/profile'>Profile</Button>*/}
            {new Date(this.props.mindfile.created_at) > new Date("2023-11-15") ? null :
              <Button color="inherit" component={Link} to='/avatar'>Avatar</Button>
            }
            {this.props.isCurrentMindfileOwner
              ? <Button color="inherit" component={Link} to='/social'>Social</Button>
              : null
            }
            <Button color="inherit" component={Link} to='/spacecast'>Spacecast</Button>
            {this.props.user.is_admin ? <Button color="inherit" component={Link} to='/admin'>Admin</Button> : null}
            {this.props.isCurrentMindfileOwner
              ? <Button color="inherit" component={Link} to='/settings'>Settings</Button>
              : this.props.isCurrentMindfileContributor
                ? <Button color="inherit" component={Link} to='/contributor-settings'>Settings</Button>
                : null}
            <Button color="inherit" href="#help_load">Help</Button>
            <Button color="inherit" onClick={this.props.openContactDialog}>Contact</Button>
            <Button color="inherit" component={Link} to='/logout'>Logout</Button>
          </Hidden>
          <Hidden mdUp>
            <IconButton color="inherit" onClick={this.props.toggleRightDrawer} className={classes.menuButton}>
              <MenuIcon />
            </IconButton>
          </Hidden>
        </Toolbar>
      </AppBar>
    )
  }
}

const mapStateToProps = state => ({
  user: state.auth,
  isCurrentMindfileOwner: state.isCurrentMindfileOwner,
  isCurrentMindfileContributor: state.isCurrentMindfileContributor,
  mindfile: state.mindfile,
})

const mapDispatchToProps = {
  getMindfile
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MainAppBar))
